var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleplayicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18.053px",
    height: "20.109px",
    viewBox: "0 0 18.053 20.109",
    enableBackground: "new 0 0 18.053 20.109",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    fill: "#2BC2F1",
    d: "M0.362,0.31C0.106,0.617-0.024,1.01,0,1.41v17.289c-0.024,0.399,0.105,0.793,0.361,1.1         l0.059,0.057l9.686-9.687V9.94L0.42,0.255L0.362,0.31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    fill: "#FCDA00",
    d: "M13.334,13.399l-3.229-3.23V9.94l3.229-3.229l0.073,0.042l3.824,2.174         c0.624,0.204,0.964,0.874,0.761,1.497c-0.117,0.36-0.4,0.643-0.761,0.761l-3.824,2.174L13.334,13.399z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    fill: "#FB003B",
    d: "M13.408,13.356l-3.301-3.3l-9.744,9.742c0.46,0.405,1.143,0.426,1.625,0.049l11.422-6.49"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    fill: "#33CC68",
    d: "M13.408,6.752L1.987,0.262C1.504-0.115,0.822-0.095,0.362,0.31l9.744,9.745L13.408,6.752z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayicon);
export default __webpack_public_path__ + "static/media/googleplayicon.183f9d25.svg";
export { ForwardRef as ReactComponent };